import { Icon, utils as u, enums as e } from 'edrolo-ui';
import s from './styles.scss';
import cx from 'classnames';

interface ClosedBannerProps {
  isArchived?: boolean;
}

export const ClosedBanner = ({ isArchived = false }: ClosedBannerProps) => {
  return (
    <div className={s.closedBanner}>
      <div className={cx(u.flex, u.alignCenter, u.gap2, u.textCenter)}>
        <Icon name={e.Icons.LOCK_CLOSED_FILLED} />
        <p className={cx(u.mb0, u.semibold)}>
          {isArchived
            ? 'This task has been archived.'
            : 'This task has been closed.'}
        </p>
      </div>
    </div>
  );
};
